import { render, staticRenderFns } from "./ResearchForm.vue?vue&type=template&id=68134aaf&scoped=true"
import script from "./ResearchForm.vue?vue&type=script&lang=js"
export * from "./ResearchForm.vue?vue&type=script&lang=js"
import style0 from "./ResearchForm.vue?vue&type=style&index=0&id=68134aaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68134aaf",
  null
  
)

export default component.exports